import { useState } from 'react';
import { VisibilityOff } from '@material-ui/icons';
import { Tooltip } from '../../Tooltip';
import clsx from 'clsx';

interface Props {
  keys: string[];
  colors: string[];
  onHide(item: any): void;
}

export const CustomLegend = ({ keys, colors, onHide }: Props) => {
  const [hiddenKeys, setHiddenKeys] = useState<string[]>([]);

  const getShape = (shape: string, index: number) => {
    switch (shape.toLowerCase()) {
      case 'circle':
        return (
          <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="50" fill={colors[index]} />
          </svg>
        );
      case 'triangle':
        return (
          <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <polygon points="50,0 100,100 0,100" fill={colors[index]} />
          </svg>
        );
    }
  };

  const hideKeys = (key: string) => {
    let curItems = hiddenKeys;

    curItems.includes(key)
      ? curItems.splice(curItems.indexOf(key), 1)
      : curItems.push(key);

    setHiddenKeys(curItems);
  };

  return (
    <div className="flex flex-row items-center justify-evenly h-[30px] p-0.5 w-full m-1 cursor-pointer">
      {keys.map((key, index) => (
        <div
          key={`legend-key-${index}`}
          className="inline-block items-center m-auto max-w-[20%] text-ellipsis overflow-hidden"
        >
          <div
            className="flex justify-center items-center w-4 h-4 !mb-0.5 m-auto hover:opacity-80"
            onClick={() => {
              hideKeys(key);
              onHide(key);
            }}
          >
            {hiddenKeys.includes(key) ? (
              <VisibilityOff className={clsx('p-1 hover:opacity-80')} />
            ) : (
              getShape('circle', index)
            )}
          </div>
          <Tooltip title={key} showArrow placement="bottom">
            <span className="text-xs text-center whitespace-nowrap ">
              {key}
            </span>
          </Tooltip>
        </div>
      ))}
    </div>
  );
};
